import script from "./TabPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPanel.vue?vue&type=script&setup=true&lang=js"

import "./TabPanel.vue?vue&type=style&index=0&id=9793ef8a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9793ef8a"]])

export default __exports__